import { html } from 'lit';
import { Download } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-download')
export class PdsIconDownload extends PdsIcon {
  @state()
  icon = Download;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
